// import { useEffect } from 'react'
import {Outlet} from 'react-router-dom'

import {Paper} from 'common/components'
import {TopPanel} from './components'
// import { useRBACLogin } from './api/auth'
// import { setSession } from './store/session'

export const RBACPage = () => {
  // const { mutate: login } = useRBACLogin(setSession)

  // useEffect(() => {
  //   login({
  //     email: 'harryhaibojiang@gmail.com',
  //     password: '111111',
  //   })
  // }, [login])

  return (
    <Paper>
      <TopPanel />
      <Outlet />
    </Paper>
  )
}
